angular.module('bmsApp.settings')
	.factory('FranchiseSvc', function ($http, $log, $window, $q, CRUDSvc) {
		return {
			read: function () {
				return CRUDSvc.get('api/franchise/read');
			},
			save: function(param) {
				return CRUDSvc.post('api/franchise/save', param);
			},
			businessAddressTypes: function(params) {
				return CRUDSvc.get('api/businessAddressTypes/options', params);
			},
			salesCodes:function(){
				return CRUDSvc.get('api/sales-codes/read');
			}
		};
	});

